"use strict";
/**
* Models.ts
* Author: CALIB http://aka.ms/CALIB
* Copyright: Microsoft 2017
*
* ECS models
*/
Object.defineProperty(exports, "__esModule", { value: true });
var EcsConfigType;
(function (EcsConfigType) {
    EcsConfigType[EcsConfigType["Default"] = 0] = "Default";
    EcsConfigType[EcsConfigType["User"] = 1] = "User";
})(EcsConfigType = exports.EcsConfigType || (exports.EcsConfigType = {}));
